import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import ListEmployees from "./List";
import CreateEmployees from "./Create";
import { EMPLOYEES, EmployeeServicePath } from "utils/constants";
import EditEmployees from "./Edit";
import ShowEmployee from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";
//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU, tenants.SU],
  icon: <PermContactCalendarIcon />,
  name: EmployeeServicePath + EMPLOYEES,
  title: "Служители",
  list: <ListEmployees />,
  create: <CreateEmployees />,
  createPermission: permissions.canCreateEmployees,
  edit: <EditEmployees />,
  editPermission: permissions.canUpdateEmployees,
  show: <ShowEmployee />,
  showPermission: permissions.canPreviewEmployees,
  permission: permissions.canPreviewEmployees,
};
